import { render } from "./InterfaceDialogContainer.vue?vue&type=template&id=3bdb70c4&scoped=true"
import script from "./InterfaceDialogContainer.vue?vue&type=script&lang=js"
export * from "./InterfaceDialogContainer.vue?vue&type=script&lang=js"

import "./InterfaceDialogContainer.vue?vue&type=style&index=0&id=3bdb70c4&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdb70c4"]])

export default __exports__